import { render, staticRenderFns } from "./Totals.vue?vue&type=template&id=4b372899&scoped=true"
import script from "./Totals.vue?vue&type=script&lang=ts"
export * from "./Totals.vue?vue&type=script&lang=ts"
import style0 from "./Totals.vue?vue&type=style&index=0&id=4b372899&scoped=true&lang=css"
import style1 from "./Totals.vue?vue&type=style&index=1&id=4b372899&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b372899",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b372899')) {
      api.createRecord('4b372899', component.options)
    } else {
      api.reload('4b372899', component.options)
    }
    module.hot.accept("./Totals.vue?vue&type=template&id=4b372899&scoped=true", function () {
      api.rerender('4b372899', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products-table/Totals.vue"
export default component.exports